import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import WelcomeSection from './components/WelcomeSection';
import CoursesSection from './components/CoursesSection';
import DubbedSection from './components/DubbedSection';
import BookStoreSection from './components/BookStoreSection';
import AskDrNawwafSection from './components/AskDrNawwafSection';
import CharitiesSection from './components/CharitiesSection';
import TeachingsSection from './components/TeachingsSection';
import MissionVisionSection from './components/MissionVisionSection';
import DonationSection from './components/DonationSection';
import Footer from './components/Footer';
import AuthCallback from './components/AuthCallback';
import AdminLogin from './components/admin/AdminLogin';
import AdminPanel from './components/admin/AdminPanel';
import PurchaseHistory from './components/PurchaseHistory';
import PrivacyPolicy from './components/legal/PrivacyPolicy';
import TermsOfService from './components/legal/TermsOfService';
import CookiePolicy from './components/legal/CookiePolicy';
import RefundPolicy from './components/legal/RefundPolicy';
import PaymentSuccess from './components/PaymentSuccess';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-[#0f0a1a]">
      <Navbar />
      <HeroSection />
      <WelcomeSection />
      <CoursesSection />
      <DubbedSection />
      <BookStoreSection />
      <AskDrNawwafSection />
      <CharitiesSection />
      <TeachingsSection />
      <MissionVisionSection />
      <Footer />
    </div>
  );
};

// Router component that handles session_id in URL
const AppRouter = () => {
  const location = useLocation();
  
  // Check URL fragment for session_id (OAuth callback)
  // CRITICAL: This must be synchronous during render to prevent race conditions
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/my-books" element={<PurchaseHistoryPage />} />
      {/* Hidden admin routes with complex URLs */}
      <Route path="/ctrl-9x7k2m-auth-8f3j5n-secure-4w6r9t" element={<AdminLogin />} />
      <Route path="/ctrl-9x7k2m-panel-8f3j5n-admin-4w6r9t" element={<AdminPanel />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/cookie-policy" element={<CookiePolicy />} />
      <Route path="/refund-policy" element={<RefundPolicy />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
    </Routes>
  );
};

// Purchase History Page wrapper
const PurchaseHistoryPage = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#0f0a1a]">
      <Navbar />
      <PurchaseHistory onBack={() => navigate('/')} />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <div className="App">
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </div>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
